var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/lib/NodeIdPlugin.ts
import {
  createTSlatePlugin,
  isBlock,
  isElement,
  nanoid,
  queryNode as queryNode2
} from "@udecode/plate-common";

// src/lib/withNodeId.ts
import {
  applyDeepToNodes,
  defaultsDeepToNodes,
  isDefined,
  queryNode,
  someNode
} from "@udecode/plate-common";
import castArray from "lodash/castArray.js";
import cloneDeep from "lodash/cloneDeep.js";
var withNodeId = ({
  editor,
  getOptions
}) => {
  const { apply, insertNode, insertNodes } = editor;
  const idPropsCreator = () => {
    var _a;
    return {
      [(_a = getOptions().idKey) != null ? _a : ""]: getOptions().idCreator()
    };
  };
  const filterNode = (nodeEntry) => {
    var _a;
    const { filter, filterText } = getOptions();
    return filter(nodeEntry) && (!filterText || ((_a = nodeEntry[0]) == null ? void 0 : _a.type) !== void 0);
  };
  const removeIdFromNodeIfDuplicate = (node) => {
    const { idKey = "", reuseId } = getOptions();
    if (!reuseId || someNode(editor, { at: [], match: { [idKey]: node[idKey] } })) {
      delete node[idKey];
    }
  };
  const overrideIdIfSet = (node) => {
    const { idKey = "" } = getOptions();
    if (isDefined(node._id)) {
      const id = node._id;
      delete node._id;
      if (!someNode(editor, { at: [], match: { [idKey]: id } })) {
        node[idKey] = id;
      }
    }
  };
  editor.insertNodes = (_nodes, options) => {
    const nodes = castArray(_nodes).filter((node) => !!node);
    if (nodes.length === 0) return;
    const { disableInsertOverrides, idKey = "" } = getOptions();
    insertNodes(
      nodes.map((node) => {
        if (!disableInsertOverrides && node[idKey]) {
          node._id = node[idKey];
        }
        return node;
      }),
      options
    );
  };
  editor.insertNode = (node) => {
    const { disableInsertOverrides, idKey = "" } = getOptions();
    if (!disableInsertOverrides && node[idKey]) {
      node._id = node[idKey];
    }
    insertNode(node);
  };
  editor.apply = (operation) => {
    const {
      allow,
      disableInsertOverrides,
      exclude,
      idCreator,
      idKey = "",
      reuseId
    } = getOptions();
    const query = {
      allow,
      exclude,
      filter: filterNode
    };
    if (operation.type === "insert_node") {
      const node = cloneDeep(operation.node);
      applyDeepToNodes({
        apply: removeIdFromNodeIfDuplicate,
        node,
        query,
        source: {}
      });
      defaultsDeepToNodes({
        node,
        path: operation.path,
        query,
        source: idPropsCreator
      });
      if (!disableInsertOverrides) {
        applyDeepToNodes({
          apply: overrideIdIfSet,
          node,
          query,
          source: {}
        });
      }
      return apply(__spreadProps(__spreadValues({}, operation), {
        node
      }));
    }
    if (operation.type === "split_node") {
      const node = operation.properties;
      let id = operation.properties[idKey];
      if (queryNode([node, operation.path], query)) {
        if (!reuseId || id === void 0 || someNode(editor, {
          at: [],
          match: { [idKey]: id }
        })) {
          id = idCreator();
        }
        return apply(__spreadProps(__spreadValues({}, operation), {
          properties: __spreadProps(__spreadValues({}, operation.properties), {
            [idKey]: id
          })
        }));
      }
      if (id) {
        delete operation.properties[idKey];
      }
    }
    return apply(operation);
  };
  return editor;
};

// src/lib/NodeIdPlugin.ts
var NodeIdPlugin = createTSlatePlugin({
  key: "nodeId",
  extendEditor: withNodeId,
  normalizeInitialValue: ({ editor, getOptions }) => {
    const {
      allow,
      exclude,
      filter,
      filterInline,
      filterText,
      idKey,
      normalizeInitialValue
    } = getOptions();
    if (!normalizeInitialValue) {
      const firstNode = editor.children[0];
      const lastNode = editor.children.at(-1);
      if ((firstNode == null ? void 0 : firstNode.id) && (lastNode == null ? void 0 : lastNode.id)) {
        return editor.children;
      }
    }
    const addNodeId = (entry) => {
      var _a;
      const [node, path] = entry;
      const newNode = __spreadValues({}, node);
      if (!newNode[idKey] && queryNode2([node, path], {
        allow,
        exclude,
        filter: (entry2) => {
          const [node2] = entry2;
          if (filterText && !isElement(node2)) {
            return false;
          }
          if (filterInline && isElement(node2) && !isBlock(editor, node2)) {
            return false;
          }
          return filter(entry2);
        }
      })) {
        newNode[idKey] = getOptions().idCreator();
      }
      if (((_a = newNode.children) == null ? void 0 : _a.length) > 0) {
        newNode.children = newNode.children.map(
          (child, index) => addNodeId([child, [...path, index]])
        );
      }
      return newNode;
    };
    return editor.children.map(
      (node, index) => addNodeId([node, [index]])
    );
  },
  options: {
    filter: () => true,
    filterInline: true,
    filterText: true,
    idCreator: () => nanoid(10),
    idKey: "id",
    normalizeInitialValue: false
  }
});
export {
  NodeIdPlugin,
  withNodeId
};
//# sourceMappingURL=index.mjs.map